import React from 'react';
import { Checkbox } from 'antd';

import styles from './index.module.less';

export const NodeOptions = ({
  value,
  onChange,
  targetIndex,
  parentNode,
  renderNode,
  currentClickNode,
  handleNodeClick,
  checkedAble
}: any) => {
  if (!value) {
    return <></>;
  }
  const { children = [], label, open, checked, disabled } = value;
  const childUIs = children?.map((child: any, index: number) => (
    <NodeOptions
      key={index}
      targetIndex={index}
      renderNode={renderNode}
      value={child}
      parentNode={value}
      onChange={onChange}
      currentClickNode={currentClickNode}
      handleNodeClick={handleNodeClick}
      checkedAble={checkedAble}
    />
  ));


  // checkedAble
  let checkedAbleRes = true;
  if(checkedAble === false || disabled) {
    checkedAbleRes = false
  }
  if(typeof checkedAble === 'function') {
    checkedAbleRes = checkedAble(value);
  }

  // node-style
  let nodeStyle = currentClickNode === value ? { background: '#e6f4ff' } : undefined; 
   
  return (
    <div className={styles.role_node_wrap}>
      {parentNode && (
        <>
          {targetIndex !== 0 && <div className={styles.column_top_line} />}
          {targetIndex !== (parentNode as any)?.children?.length - 1 && (
            <div className={styles['column_line']} />
          )}
          <div className={styles['row_line']} />
        </>
      )}
      {renderNode ? (
        renderNode({
          value,
          onCheckedChange: () => {
            value.checked = !checked;
            onChange();
          },
        })
      ) : (
        <div
          className={styles['box-item']}
          style={nodeStyle}
        >
          {
            checkedAbleRes && (
              <Checkbox
              checked={checked}
              disabled={disabled}
              onChange={() => {
                value.checked = !checked;
                onChange();
              }}
            />
            )
          }
          <div
            className={styles['label-item']}
            onClick={() => {
              handleNodeClick(value);
            }}
          >
            {label}
          </div>
        </div>
      )}

      {!!children?.length && (
        <div className={styles['expend-box']}>
          <div
            className={styles['logic-tip-box']}
            onClick={() => {
              value.open = value.open === false ? true : false;
              onChange();
            }}
          >
            {open === false ? '-' : '+'}
          </div>
        </div>
      )}
      {open !== false && (
        <>
          {!!children?.length && <div className={styles['expend-line']} />}
          <div className={styles.children_Wrap}>{childUIs}</div>
        </>
      )}
    </div>
  );
};
